import type { ReferencedTweetSummaryEngagementAllOf } from './referencedTweetSummaryEngagementAllOf';
import type { ReferencedTweetSummaryEngagementAllOfTwo } from './referencedTweetSummaryEngagementAllOfTwo';

export type ReferencedTweetSummaryEngagement = ReferencedTweetSummaryEngagementAllOf & ReferencedTweetSummaryEngagementAllOfTwo;
